import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
    data: {
      title: 'Login | Tapgo',
      description: 'Description on page',
    },
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/main-wrapper/main-wrapper.module').then(
        (m) => m.MainWrapperModule
      ),
    data: {
      title: 'Dashboard | Tapgo',
      description: 'Description on page',
    },
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
